import React from 'react';
import { Button } from 'primereact/button';
import {
  DatePickerInputField,
  InputField,
  SelectField,
} from '../../../../components/FormikFields';
import { SELECT_AN_OPTION_LABEL } from '../../../../constants/common';
import moment from 'moment';

export const invoiceStatementConfig = ({ t, values, toggleFieldsHandler }) => [
  {
    fields: [
      {
        name: 'typeOfView',
        label: t('invoice_statement.type_of_view'),
        className: 'col-12',
        component: SelectField,
        componentProps: {
          options: [
            {
              value: SELECT_AN_OPTION_LABEL,
              label: t('invoice_statement.select_here'),
            },
            { value: 'SALES', label: t('invoice_list.sales') },
            { value: 'PURCHASES', label: t('invoice_list.purchase') },
            { value: 'THIRD_PARTY', label: t('invoice_list.third_party') },
          ],
        },
        required: true,
      },
    ],
  },
  {
    fields: [
      {
        name: 'emailAddress',
        label: t('invoice_statement.email_address'),
        className: 'col-12',
        component: InputField,
        componentProps: {
          placeholder: t('invoice_statement.email_address_placeholder'),
        },
        required: true,
      },
    ],
  },
  {
    fields: [
      {
        name: 'startDate',
        label: t('invoice_statement.time_period'),
        className: 'col-6',
        component: DatePickerInputField,
        componentProps: {
          placeholder: t('statement.select_start_date'),
          className: 'w-100',
          minDate: moment(values.endDate, 'DD/MM/YYYY')
            .subtract(3, 'months')
            .format('DD/MM/YYYY'),
          maxDate: values.endDate || new Date(),
          dateFormat: 'DD-MM-YYYY',
        },
        required: true,
      },
      {
        name: 'endDate',
        className: 'col-6',
        component: DatePickerInputField,
        componentProps: {
          placeholder: t('statement.select_end_date'),
          className: 'w-100',
          dateFormat: 'DD-MM-YYYY',
          minDate: values.startDate,
          maxDate: moment(values.startDate, 'DD/MM/YYYY')
            .add(3, 'months')
            .format('DD/MM/YYYY'),
        },
      },
    ],
  },
  {
    fields: [
      {
        name: 'dataFields',
        component: () => (
          <Button
            type="button"
            link
            className="p-0 gap-2"
            onClick={() => toggleFieldsHandler(true)}
          >
            {t('invoice_statement.customize_data_fields')}
            <i className="pi pi-file-edit" />
          </Button>
        ),
        className: 'col-6 dataFieldsInput',
      },
    ],
  },
];
